/**
 * Toggles an element in an array - adds it if not present, removes it if present
 * @param {Array} array - The source array
 * @param {*} element - The element to toggle
 * @returns {Array} A new array with the element toggled
 */
export const toggleArrayItem = (array, element) => (array.includes(element)
  ? array.filter(item => item !== element)
  : [...array, element]);
